interface IGetLanguageCode {
  language: string;
  locale?: string;
}

export const getLanguageCode = ({ language, locale }: IGetLanguageCode) =>
  locale ? `${language}-${locale}` : language;
